import base from './classes'
import { cloneDeep } from 'lodash'

const derived = cloneDeep(base)

derived.getters.columns = (state, getters, rootState) => {
  const cols = base.getters.columns(state, getters, rootState)

  cols.find(col => col.name === 'capacity').hideWhenDisplaying = false
  cols.find(col => col.name === 'standby_capacity').hideWhenDisplaying = false
  cols.find(col => col.name === 'converted_standby_count').hideWhenDisplaying = false
  cols.find(col => col.name === 'expected_checked_in_all_bookings').hideWhenDisplaying = false
  cols.find(col => col.name === 'cml_late_cancels_and_noshows').hideWhenDisplaying = false
  cols.find(col => col.name === 'expected_final_late_cancels_and_noshows_alpha_50').hideWhenDisplaying = false

  return cols
}

export default derived
